<!-- Guide Tour Modal - Based on Figma Design -->
<div
  class="guide-tour-modal"
  *ngIf="guideTourService.isOpen()"
  (click)="onOverlayClick()"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'guide-tour-title'"
>
  <div class="guide-tour-modal__content" (click)="onContentClick($event)" [@fadeSlideIn]>
    <!-- Close button (hidden per design, but accessible) -->
    <button
      class="guide-tour-modal__close-btn visually-hidden"
      type="button"
      (click)="onSkip()"
      aria-label="Close guide tour"
    >
      <span aria-hidden="true">&times;</span>
    </button>

    <!-- Main Title with highlighted "quick tour" -->
    <h2 id="guide-tour-title" class="guide-tour-modal__title">
      <span class="guide-tour-modal__title-line guide-tour-modal__title-line--first">
        Let's take a&nbsp;<span class="guide-tour-modal__title-highlight">quick tour</span>&nbsp;to
      </span>
      <span class="guide-tour-modal__title-line guide-tour-modal__title-line--second"> get you started. </span>
    </h2>

    <!-- Illustration -->
    <div class="guide-tour-modal__illustration">
      <img
        *ngIf="currentStepData()?.illustrationSrc && !showPlaceholder"
        [src]="currentStepData()?.illustrationSrc"
        [alt]="'Step ' + guideTourService.currentStep() + ' illustration'"
        class="guide-tour-modal__illustration-img"
        (error)="onImageError($event)"
      />
      <!-- Fallback placeholder when image fails to load -->
      <div
        *ngIf="showPlaceholder || !currentStepData()?.illustrationSrc"
        class="guide-tour-modal__illustration-placeholder"
        aria-hidden="true"
      >
        <svg width="132" height="88" viewBox="0 0 132 88" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M132 0H0V88H132V0Z" fill="#E8E8E8" />
          <path
            d="M66 20C59.3726 20 54 25.3726 54 32C54 38.6274 59.3726 44 66 44C72.6274 44 78 38.6274 78 32C78 25.3726 72.6274 20 66 20Z"
            fill="#D0D0D0"
          />
          <path d="M42 68L54 50L66 62L78 44L90 68H42Z" fill="#D0D0D0" />
        </svg>
      </div>
    </div>

    <!-- Step Info Block -->
    <div class="guide-tour-modal__step-info">
      <!-- Step Title: "Step X:" in #BABABA, rest in #282003 -->
      <h3 class="guide-tour-modal__step-title">
        <span class="guide-tour-modal__step-label">Step {{ guideTourService.currentStep() }}:</span>
        {{ currentStepData()?.title?.split(": ")?.[1] || currentStepData()?.title }}
      </h3>

      <!-- Step Description -->
      <p class="guide-tour-modal__step-description">
        {{ currentStepData()?.description }}
      </p>
    </div>

    <!-- Action Buttons -->
    <div
      class="guide-tour-modal__actions"
      [class.guide-tour-modal__actions--single]="currentStepData()?.actions?.length === 1"
    >
      <button
        *ngFor="let action of currentStepData()?.actions; let i = index"
        type="button"
        class="guide-tour-modal__action-btn"
        [class.guide-tour-modal__action-btn--secondary]="action.variant === 'secondary'"
        (click)="onActionClick(action)"
      >
        <img
          *ngIf="action.iconSrc"
          [src]="action.iconSrc"
          [alt]="''"
          class="guide-tour-modal__action-icon"
          aria-hidden="true"
        />
        {{ action.label }}
      </button>
    </div>

    <!-- Navigation -->
    <div class="guide-tour-modal__navigation">
      <!-- Previous Step Button -->
      <button
        class="guide-tour-modal__nav-btn"
        type="button"
        [disabled]="!guideTourService.canGoPrevious()"
        (click)="onPrevious()"
        [attr.aria-label]="'Go to step ' + (guideTourService.currentStep() - 1)"
      >
        Prev step
      </button>

      <!-- Step Counter -->
      <span class="guide-tour-modal__step-counter">
        {{ guideTourService.currentStep() }} / {{ guideTourService.totalSteps() }}
      </span>

      <!-- Next Step Button -->
      <button
        class="guide-tour-modal__nav-btn"
        type="button"
        [disabled]="!guideTourService.canGoNext()"
        (click)="onNext()"
        [attr.aria-label]="'Go to step ' + (guideTourService.currentStep() + 1)"
      >
        Next step
      </button>
    </div>

    <!-- Divider -->
    <div class="guide-tour-modal__divider" aria-hidden="true"></div>

    <!-- Skip Button -->
    <button class="guide-tour-modal__skip-btn" type="button" (click)="onSkip()">Skip and view the guide later</button>
  </div>
</div>
